import { render, staticRenderFns } from "./SearchBarView.vue?vue&type=template&id=4fb8a936&"
import script from "./SearchBarView.vue?vue&type=script&lang=js&"
export * from "./SearchBarView.vue?vue&type=script&lang=js&"
import style0 from "./SearchBarView.vue?vue&type=style&index=0&id=4fb8a936&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports